<ng-container *ngIf="barcodeValue$ | async as barcodeValue">
  <div class="barcode p-0 d-flex flex-wrap flex-column justify-content-around align-items-center">
    <div class="w-100 bg-primary barcode-content-container">
      <div class="qr-card bg-glass d-flex flex-column align-items-center justify-content-center">
        <div class="qr">
          <qrcode [qrdata]="barcodeValue" [width]="100" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
        </div>
        <p class="scan-text text-white font-size-12 text-center mb-0">
          {{ 'wallet.barcode.scan' | translate : { fgbdefault: 'Scan Member Barcode' } }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
